import { ChatStore } from "@/stores/ChatStore";
import BrandGroup from "./brand-group";

type TDisplayedExternalLinksProps = {
}

export default function DisplayedExternalLinks({
}: TDisplayedExternalLinksProps) {
  const displayedExternalLinks = ChatStore(state => state.displayedExternalLinks);

  if (displayedExternalLinks.every(group => group.items.length === 0)) {
    return null;
  }

  return (
    <div className={"overflow-hidden rounded-lg"}>
      <div className={"max-h-96 overflow-y-auto bg-white opacity-90 py-3 px-2 shadow-lg"}>
        {displayedExternalLinks.map((group, index) => (
          <BrandGroup group={group} key={index} />
        ))}
      </div>
    </div>
  );
}